export default {
	INTERACTIONS: 'companies/:company_id/interactions/',
}
